import { DataProvider, Identifier, Translate } from "react-admin";
import { ErrorMessage } from "../../common/components/utils/error";
import { filter } from "../../common/components/utils/fn";
import { findAndAction } from "../common/common";

export interface Project {
    id: Identifier;
    name: string;
    description: string;
    workflowId: Identifier;
    unitMeasure: string;
    unitProd: string;
    status: string;
    customDashboard: boolean;
    dashboard: number;
    hasMap:boolean;
};

export interface StageInfos {
    id: Identifier;
    stageId: Identifier;
    quantity: number;
    duration: number;
    assignId: Identifier;
    unitTime: string;
    isSubproject: Boolean;
    subprojectId?: Identifier;
};

export const projectValidate = (dataProvider: DataProvider, translate: Translate, record: Project) => async (): Promise<ErrorMessage[]> => {
    const errors = [];
    const stageIds = [];
    await findAndAction(dataProvider, "stage_infos", { projectId: record.id }, (data) => {
        stageIds.push(parseInt(`${data.stageId}`, 10));
    });
    const key = "resources.validate.requiredFieldFor";
    const field = translate("resources.project.stages.name");
    await findAndAction(dataProvider, "stage", { workflowId: record.workflowId, id: filter(null, stageIds, "_nin") }, (data) => {
        const args = { field, for: translate("resources.project.errors.for", { name: data.name }) }
        errors.push({ key, args });
    });
    return errors;
}

export const selectStage = (redirect: Function, id?: string) => {
    const p = document.location.hash.split("#")[1];
    if (id) {
        const s = p.split("/", 5);
        if (s.length === 5) {
            const lastValue = s.pop();
            if (lastValue === `${id}`) {
                redirect(s.join("/"));
            } else {
                redirect(`${s.join("/")}/${id}`);
            }
        } else {
            redirect(`${s.join("/")}/${id}`);
        }
    } else {
        redirect(p.split("/", 4).join("/"))
    }
}